import React from "react";
import { createRoot } from "react-dom/client";

import RootNavigator from "./navigators/RootNavigator";

createRoot(document.getElementById("root")!).render(<RootNavigator />);
